module.exports = __webpack_public_path__ + "static/media/boost-hero.b7a3c136.svg";